export const getStepSizeFromWidthPerSecond = (widthPerSecond: number): number => {
  if (widthPerSecond >= 250) {
    return 0.5;
  }

  if (widthPerSecond >= 80) {
    return 1;
  }

  if (widthPerSecond >= 70) {
    return 2;
  }

  if (widthPerSecond >= 60) {
    return 3;
  }

  if (widthPerSecond >= 45) {
    return 5;
  }

  if (widthPerSecond >= 30) {
    return 10;
  }

  if (widthPerSecond >= 15) {
    return 15;
  }

  if (widthPerSecond >= 5) {
    return 30;
  }

  return 60;
};

export const getStepSizeFromWidthPerSecondForMobile = (widthPerSecond: number): number => {
  if (widthPerSecond >= 20) {
    return 0.5;
  }

  if (widthPerSecond >= 10) {
    return 1;
  }

  if (widthPerSecond >= 5) {
    return 2;
  }

  if (widthPerSecond >= 2.5) {
    return 5;
  }

  return 10;
};
